import {Provider} from 'domain/usecases/private/authorizations/get-providers-list';
import {GlobalExternalLinkEnum} from 'presentation/constants';

export const openGoogleMaps = (provider: Provider) => {
	const {nmEndereco, nmCidade, cdUF} = provider || {};

	const queryParts = [nmEndereco, nmCidade, cdUF].filter(Boolean);
	const query = queryParts.join(', ');

	const url = `${GlobalExternalLinkEnum.GOOGLE_MAPS}/?q=${encodeURIComponent(query)}`;

	window.open(url);
};
